
import Ajax from '../js/common/ajax';
/**
 * 报表模版接口
 */
export default {
	template: {
		list() {
			return Ajax.get("/report/template")
		},
		load(id) {
			return Ajax.get(`/report/template/${id}`)
		},
		delete(id) {
			return Ajax.delete(`/report/template/${id}`)
		},
		save(params = {}) {
			return Ajax.post(`/report/template`, params)
		},
		update(params = {}) {
			return Ajax.put(`/report/template`, params)
		},
		items: {
			save(params = {}) {
				return Ajax.post(`/report/template/items`, params)
			},
			update(params = {}) {
				return Ajax.put(`/report/template/items`, params)
			},
			delete(id) {
				return Ajax.delete(`/report/template/items/${id}`)
			},
			formula(params) {
				return Ajax.post(`/report/template/items/formula`, params)
			}
		}
	},
	view(id, params = {}) {
		return Ajax.get(`/report/template/view/${id}`, params)
	},
	jingLi: {
		list() {
			return Ajax.get("/csjingli")
		},
		load(id) {
			return Ajax.get(`/csjingli/${id}`)
		},
		delete(id) {
			return Ajax.delete(`/csjingli/${id}`)
		},
		save(params = {}) {
			return Ajax.post(`/csjingli`, params)
		},
		update(params = {}) {
			return Ajax.put(`/csjingli`, params)
		},
		batchUpdate(params = {}) {
			return Ajax.put(`/csjingli/batch-update`, params)
		}
	}
}